import { useEffect, useRef } from "react";
import {
  getLocalJWT,
  getLocalUser,
  getLocalUserId,
} from "../functions/utilities";
import { useAppDispatch } from "../../redux/reduxHooks";
import { useNavigate } from "react-router";
import { socketInit } from "./socketInit";

const useSocketOnPc = () => {
  const socket = useRef(null);
  const userId = getLocalUserId();
  const userDetails = getLocalUser();
  const token = getLocalJWT();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    socket.current = socketInit(userId.toString(), token);

    // const roomId = `pc_${userDetails?.companyId}`;

    // Function to join a room
    const joinRoom = () => {
      const roomId = `pc_${userDetails?.companyId}`;
      socket.current.emit("JOIN_PC_ROOM", { roomId });
    };

    const handleConnect = () => {
      console.log("connected");
      // Automatically join the room upon connecting or reconnecting
      joinRoom();
    };

    socket.current.on("connect", () => {
      //   socket.current.emit("JOIN_PC_ROOM", {
      //     roomId: `pc_${userDetails?.companyId}`,
      //   });
      console.log("connected");
      handleConnect();
    });

    socket.current.on("JOIN_PC_ACK", (message) => {
      console.log("CONNECTED FROM SERVER", socket.current.id);
    });

    const leaveRoom = () => {
      const roomId = `pc_${userDetails?.companyId}`;
      socket.current.emit("LEAVE_PC_ROOM", { roomId });
    };

    // Add beforeunload event listener
    const handleBeforeUnload = () => {
      leaveRoom(); // Attempt to leave the room when the page is about to be unloaded
      // You might not be able to guarantee this operation completes
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      leaveRoom();
      socket.current.off("connect", handleConnect);
      socket.current.disconnect();
      window.removeEventListener("beforeunload", handleBeforeUnload); // Remove the event listener on cleanup
    };
  }, []);

  // Function to leave a room

  return {};
};

export default useSocketOnPc;
